import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../App.scss';
import logo from '../logo.svg';
import Favicon from 'react-favicon';

const Header = () => {
  const [faviconUrl] = useState('https://takanen.eu/favicon.ico');
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Favicon url={faviconUrl} />
      <header className="header">
        <div className="logo-block">
          <img src={logo} alt="Lennart Takanen" className="logo" />
          <div className="studio-meta">
            <span>Lennart Takanen Photography</span>
            <strong>Y-tunnus 13467743-1 · Helsinki</strong>
          </div>
        </div>
        <nav className={`nav ${isOpen ? 'open' : ''}`}>
          <ul>
            <li>
              <Link to="/" onClick={closeMenu}>Etusivu</Link>
            </li>
            <li>
              <Link to="/pricing" onClick={closeMenu}>Hinnasto</Link>
            </li>
            <li>
              <Link to="/photo-orders" onClick={closeMenu}>Kuvatilaukset</Link>
            </li>
            <li>
              <Link to="/photographer" onClick={closeMenu}>Valokuvaaja</Link>
            </li>
            <li>
              <Link to="/portfolio" onClick={closeMenu}>Portfolio</Link>
            </li>
            <li>
              <Link to="https://blog.takanen.eu/" onClick={closeMenu}>Blogi</Link>
            </li>
            <li className="nav-cta">
              <Link to="/contact" onClick={closeMenu}>Varaa aika</Link>
            </li>
          </ul>
        </nav>
        <div className="hamburger" onClick={toggleMenu} aria-label="Avaa valikko">
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </header>
    </>
  );
};

export default Header;
